import Button from "common/components/Button/Button"
import Modal from "common/components/Modal/Modal"
import Invitation from "../../../assets/success-invitations.svg"
import "./SendBusinessInvitation.scss"

const SuccessModal = ({ visible, setInvitation }: $TSMigrationFixMe) => {
  return (
    <Modal
      closable={false}
      size='small'
      visible={visible}
    >
      <div className='w-100 d-flex  body-modal-invitation flex-column'>
        <img
          height={220}
          width={220}
          src={Invitation}
          alt='Invitaciones enviadas'
        />
        <h5 className='mt-3 title-sucess'>¡Envío correcto!</h5>
        <p className='description-sucess'>
          Las invitaciones se han enviado correctamente a todos los
          colaboradores. ¡Gracias por recomendar FinanEDI!
        </p>
        <Button
          type='button'
          onClick={() => setInvitation(false)}
          className='large'
        >
          Continuar
        </Button>
      </div>
    </Modal>
  )
}

export default SuccessModal
